import React from 'react';
import cx from 'classnames';

import Styles from './List.module.scss';
import ListHeader from './ListHeader';

const List = ({
  isLoading,
  children,
  className,
  ...otherProps
}) => {
  return (
    <div className={cx(Styles['list'], className)}>
      <ListHeader {...otherProps} isLoading={isLoading} />
      {children}
    </div>
  );
};

export default List;